import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";

export function useIsClara2Available(): boolean {
  const flagValue = useBooleanFlagValue(FeatureFlagVariables.isClara2Available, false, {
    updateOnContextChanged: true,
  });

  return flagValue === true;
}
